// Design tokens do UI Kit da Zig (Figma). Paletas tonais sao a fonte canonica;
// os grupos semanticos abaixo (orange/gray/etc) sao aliases que apontam pra elas
// pra manter os consumidores atuais funcionando. Sem azul: a marca passou a ser laranja.
const primary = {
  0: '#733C11',
  10: '#9E4F19',
  20: '#C56922',
  30: '#F58025',
  40: '#F79E5A',
  50: '#F9BE90',
  60: '#FBD4B6',
  70: '#FDEADC',
  80: '#FFF4EC',
};

const neutral = {
  0: '#726E6B',
  10: '#938F8B',
  20: '#A6A19D',
  30: '#CCC5C0',
  40: '#D4CFC9',
  50: '#E3DED9',
  60: '#F0EDE8',
  70: '#F7F4F0',
  80: '#FFFCF9',
  90: '#FFFEFC',
};

const neutralDark = {
  0: '#0E0A08',
  10: '#16110D',
  20: '#241D18',
  30: '#332C26',
  40: '#473E35',
  50: '#595044',
  60: '#696055',
};

const success = {
  0: '#1B5E20',
  10: '#2E7D32',
  20: '#4CAF50',
  30: '#A8D5BA',
  40: '#E9F7EF',
};

const error = {
  0: '#B71C1C',
  10: '#D32F2F',
  20: '#F1998E',
  30: '#FDECEA',
};

const text = '#1D1B20';

export default {
  colors: {
    primary,
    neutral,
    neutralDark,
    success,
    error,
    text,
    white: '#FFFFFF',

    // hierarquia de texto (tons quentes, espelhando o site): titulo > corpo > muted
    heading: neutralDark[30],
    muted: neutral[0],

    // acoes secundarias (antes eram azul). Neutro escuro do Figma p/ texto branco legivel.
    secondary: neutralDark[50],

    // --- aliases legados mapeados pros tokens do Figma ---
    background: {
      orange: primary[30],
      white: neutral[80],
      gray: neutral[60],
    },

    orange: {
      dark: primary[0],
      pressing: primary[20],
      primary: primary[30],
      light: primary[50],
    },

    // amarelo nao faz parte do DS do Figma; mantido como legado ate ser migrado.
    yellow: {
      pressing: '#D99837',
      primary: '#FBB040',
      light: '#FDD69B',
    },

    gray: {
      100: neutral[80],
      200: neutral[60],
      300: neutral[50],
      400: neutral[30],
      500: neutral[0],
      600: neutralDark[40],
      900: text,
    },

    attention: error[0],
    succesful: success[20],
  },
  shadow: {
    default:
      '0 6px 16px rgba(0, 0, 0, 0.13), 0 1.5px 6px rgba(0, 0, 0, 0.08)',
  },
};
